
export default function ImmersiveHeroSection() {
  return (
    <section className="bg-[#FCF8F8]">
      <div className="max-w-7xl mx-auto px-6">
        <h1 className="text-xl lg:text-2xl font-bold text-[#00889D] py-8 leading-tight">Immersive Technology</h1>
        <div className="grid lg:grid-cols-2 items-start">
          {/* Left Content */}
          <div className="space-y-8">

            <div className="space-y-6">
              <p className="text-gray-700 text-lg leading-relaxed">
                We combine practice of yoga and meditation with modern innovation through the use of{' '}
                <span className="text-[#00889D] font-medium">immersive projection technology</span>{' '}
                that transforms your yoga space into a multi-sensory sanctuary. Gentle light, flowing visuals, and
                calming soundscapes create the feeling of practicing in nature — whether surrounded by a peaceful
                forest, a glowing sunset, or a tranquil ocean. What makes immersive technology special:
              </p>

              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-[#F7F2F1] p-6 rounded-3xl shadow-lg">
                  <h3 className="text-[#00889D] font-semibold text-lg mb-3">Enhanced Mindfulness:</h3>
                  <p className="text-gray-700 text-sm">
                    Soothing visuals and soundscapes help quiet the mind and deepen focus, allowing you to be fully
                    present in your practice.
                  </p>
                </div>

                <div className="bg-[#F7F2F1] p-6 rounded-3xl shadow-lg">
                  <h3 className="text-[#00889D] font-semibold text-lg mb-3">Deeper Connection:</h3>
                  <p className="text-gray-700 text-sm">
                    Practising in a nature-inspired environment strengthens the connection between body, breath, and
                    inner awareness.
                  </p>
                </div>

                <div className="bg-[#F7F2F1] p-6 rounded-3xl shadow-lg">
                  <h3 className="text-[#00889D] font-semibold text-lg mb-3">More Restorative Sessions:</h3>
                  <p className="text-gray-700 text-sm">
                    The calming atmosphere supports relaxation, reduces stress, and enhances emotional well-being.
                  </p>
                </div>

                <div className="bg-[#F7F2F1] p-6 rounded-3xl shadow-lg">
                  <h3 className="text-[#00889D] font-semibold text-lg mb-3">Unique Experience :</h3>
                  <p className="text-gray-700 text-sm">
                    Immersive projections shift and change, offering fresh inspiration and energy in each class.
                  </p>
                </div>
              </div>

              <p className="text-gray-700 text-lg leading-relaxed py-6">
                Immerse yourself in a space designed not just for movement — but for transformation, mindfulness, and
                inner peace.
              </p>
            </div>
          </div>

          {/* Right Image */}
          <div className="flex justify-center">
            <img
                src="/img/immersiveHero.png"
                alt="Immersive Technology Yoga Studio"
                className="w-full h-auto rounded-2xl shadow-xl object-cover max-w-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
